<template>
  <router-view/>
</template>
<style lang="postcss">
.title {
  @apply text-3xl font-thin mb-3 border-b-2;
}
</style>
